/* Shipping figures are estimates; Shopify Checkout is final. */
(() => {
  function updateProduct(root=document) {
    root.querySelectorAll('[data-pf-v3-product-shipping]').forEach(panel => {
      if (panel.dataset.pfReady === '1') return;
      panel.dataset.pfReady = '1';
      const summary = panel.closest('.product-summary');
      const form = summary?.querySelector('.product-form');
      const variant = form?.querySelector('[data-variant-select]');
      const quantity = form?.querySelector('[data-product-quantity]');
      if (!variant) return;
      const price = summary.querySelector('[data-product-price]');
      const stock = summary.querySelector('[data-stock]');
      const add = form.querySelector('[data-add]');
      const label = panel.querySelector('[data-pf-shipping-price]');
      const gallery = summary.closest('.product-detail')?.querySelector('[data-product-gallery]');
      const refresh = () => {
        const option = variant.selectedOptions?.[0] || variant;
        if (price && option.dataset.price) price.textContent = option.dataset.price;
        const available = option.dataset.available !== 'false';
        if (stock) stock.textContent = available ? 'Available to order' : 'Sold out';
        if (add) { add.disabled = !available; add.textContent = available ? 'Add to Cart' : 'Sold out'; }
        if (quantity) {
          const min = Number(option.dataset.min || 1);
          quantity.min = String(min);
          quantity.step = String(Number(option.dataset.step || 1));
          quantity.value = String(Math.max(min, Number(quantity.value || min)));
          if (option.dataset.max) quantity.max = option.dataset.max;
          else quantity.removeAttribute('max');
        }
        const unitPriceCents = Number(option.dataset.pfPriceCents || 0);
        const units = Math.max(1, Number(quantity?.value || 1));
        if (label) label.textContent = unitPriceCents * units >= 6600 ? panel.dataset.pfFreeLabel : panel.dataset.pfFlatLabel;
        const mediaId = option.dataset.featuredMediaId;
        if (gallery && mediaId) {
          const featured = Array.from(gallery.children).find(item => item.dataset.mediaId === mediaId);
          if (featured && gallery.firstElementChild !== featured) gallery.prepend(featured);
        }
      };
      variant.addEventListener('change', refresh);
      quantity?.addEventListener('input', refresh);
      refresh();
    });
  }
  function initPopup(root=document) {
    root.querySelectorAll('[data-pf-v3-newsletter-popup]').forEach(popup => {
      if (popup.dataset.pfReady === '1') return;
      popup.dataset.pfReady = '1';
      const dialog = popup.querySelector('[data-pf-popup-dialog]');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const close = () => { try { sessionStorage.setItem('pf-v3-popup-dismissed', '1'); } catch (_) {} };
      const success = popup.querySelector('[data-pf-popup-success]');
      if (success) { try { localStorage.setItem('pf-v3-newsletter-subscribed', '1'); } catch (_) {} }
      dialog.querySelectorAll('[data-pf-popup-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
      dialog.addEventListener('close', close);
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      let dismissed = false;
      try { dismissed = sessionStorage.getItem('pf-v3-popup-dismissed') === '1' || localStorage.getItem('pf-v3-newsletter-subscribed') === '1'; } catch (_) {}
      const path = window.location.pathname;
      const excluded = /^\/(cart|checkout|account|policies)(\/|$)/.test(path);
      if (!dismissed && !excluded && !success) {
        window.setTimeout(() => { if (!dialog.open) dialog.showModal(); }, 25000);
      }
    });
  }
  function init(root=document) {
    root.querySelectorAll('[data-pf-cart-quantity]').forEach(input => {
      if (input.dataset.pfReady === '1') return;
      input.dataset.pfReady = '1';
      input.addEventListener('change', () => { const form=input.form; const update=form?.querySelector('[name="update"]'); if(form&&update) form.requestSubmit(update); });
    });
    root.querySelectorAll('[data-pf-newsletter]').forEach(form => {
      if (form.dataset.pfReady === '1') return;
      form.dataset.pfReady = '1';
      form.addEventListener('submit', () => { const button=form.querySelector('[data-newsletter-submit]'); if(button){button.disabled=true;button.textContent='Submitting…';} });
    });
    updateProduct(root);
    initPopup(root);
  }
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', event => init(event.target));
})();